/*
 * @Date: 2020-07-16 22:40:17
 * @LastEditTime: 2021-01-20 10:13:24
 * @LastEditors: Please set LastEditors
 */
export default {
  fixed: [
    {
      name: 'system-process',
      path: '/process/list',
      component: () => import(/* webpackChunkName: "system-process" */'../routes/process/list'),
      meta: {
        title: '系统任务进程',
        noTranslation: true,
        isNewHeader: true
      }
    }
  ]
}
